$(function() {
  NotificationSystem.init();
});

var BaseUrl = $('body').attr('baseurl');
var NotificationSystem = {
  init: function() {
    var self = this;
    this.$counters = $('.notification-counter');
    this.$container = $('#new_notifications');
    this.$error_import = $('#error_import');
    this.makeNotification = _.template(
        '<button type="button" data-id="<%= id %>" class="btn btn-xs btn-danger btn-flat dismiss-notify pull-right" title="Dispensar"> ' +
        ' <i class="fa fa-times"></i> ' +
        '</button> ' +
      '<a href="<%= data.link %>" data-id="<%= id %>" class="js-notification" >' +
      '<i class="fa fa-<%= data.task ? "exclamation-triangle" : "comment" %> text-<%= data.task ? "danger" :"warning" %>"></i>' +
      '<%= data.message %>' +
      '</a>'
    );

    $('body').on('click', '.js-notification', function(event) {
      var notification = event.currentTarget;
      var ajax = self.markAsRead(notification.dataset.id);

      startLoading();
      ajax.always(stopLoading);

      if(notification.href && notification.href !== '#') {
        event.preventDefault();
        ajax.done(function() {
          location.href = notification.href;
        });
      }
    });
    $body.on('click', '.dismiss-notify', function(event) {
      startLoading();

      var notification = event.currentTarget;
      var ajax = self.markAsRead(notification.dataset.id);

      $('[data-id="'+notification.dataset.id+'"]').remove();


      setTimeout(function () {
        $('#dropdown_notification').click();

        stopLoading();
      }, 1000);
    });

    if(this.$container.length) {
      this.verifyNotifications();
      setInterval(this.verifyNotifications.bind(this), 30000)
    }
  },
  updateCounters: function(val) {
    return this.$counters.text(val);
  },
  clearContainer: function() {
    this.$container.html('');
  },
  verifyNotifications: function() {
    var ajax = $.get(BaseUrl + '/notifications');
    ajax.done(this.successCallback.bind(this));
  },
  markAsRead: function(id) {
    return $.post(BaseUrl + '/notifications/' + id + '/mark-as-read');
  },
  successCallback: function(notifications) {
    var self = this;
    this.updateCounters(notifications.length);
    this.clearContainer();

    notifications.filter(function(notification) {
        return self.parse(notification);
    });


    $('.notifications-menu .menu').slimScroll({
      height: '200px'
    });

  },
  parse: function(notification) {
    this.$container.append(this.makeNotification(notification));
  }
};

